import { useId } from 'react';

export interface FacetOption {
  value: string;
  label: string;
  count: number;
}

export interface CheckboxFacetGroupProps {
  options: FacetOption[];
  selected: ReadonlySet<string>;
  onToggle: (value: string) => void;
}

export function CheckboxFacetGroup({
  options,
  selected,
  onToggle,
}: CheckboxFacetGroupProps) {
  const groupId = useId();

  return (
    <div className='flex flex-col gap-1 font-inter'>
      {options.map((option) => {
        const optionId = `${groupId}-${option.value}`;
        return (
          <label
            key={option.value}
            htmlFor={optionId}
            className='flex cursor-pointer items-center gap-2 rounded-md px-1.5 py-1 hover:bg-gray-50'
          >
            <input
              id={optionId}
              type='checkbox'
              checked={selected.has(option.value)}
              onChange={() => onToggle(option.value)}
              className='form-checkbox h-4 w-4 rounded border-gray-300 text-primary focus:ring-blue-500'
            />
            <span className='truncate text-sm text-gray-700'>
              {option.label}
            </span>
            <span className='ml-auto shrink-0 text-xs text-gray-400'>
              {option.count}
            </span>
          </label>
        );
      })}
    </div>
  );
}
